import React from 'react';
import PropTypes from 'prop-types';

import { ORIGIN_TOP_RIGHT, SIZE_AUTO, ORIGIN_BOTTOM_RIGHT, SuiPopoverMenu, SuiLabel } from '@splashthat/sui';

import { containerPaddingS } from 'common/styles/variables';
import Spacer from 'common/components/Spacer';

import {
    LayoutOptionStyled,
    StyledIconDiv,
    LayoutIconStyled,
    LayoutArrow,
    LayoutIconCard,
    IconContainer,
} from './LayoutOptionsMenu.styles';

import './LayoutOptionsMenu.styl';

const LAYOUT_LABEL = 'Layout';
const COMPONENT_NAME = 'LayoutOptionsMenu';
const DEFAULT_TRIGGER_BUTTON_ARIA_LABEL = 'Open Layout Option Toggle';

const preventPopoverClosingOnClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
};

export default function LayoutOptionsMenu({ onChange, options, qaId, ariaLabel }) {
    const onOptionSelected = (e, layout) => {
        preventPopoverClosingOnClick(e);
        onChange(layout);
    };

    return (
        <LayoutOptionStyled>
            <SuiPopoverMenu
                buttonElement={
                    <StyledIconDiv
                        tabIndex={0}
                        role="button"
                        data-qa={`${qaId}--LayoutOptionToggle--trigger-button`}
                        aria-label={ariaLabel}
                    >
                        <LayoutIconStyled />
                        <LayoutArrow />
                    </StyledIconDiv>
                }
                popoverProps={{
                    contentClassName: `${COMPONENT_NAME}_layoutPopover`,
                    targetOrigin: ORIGIN_TOP_RIGHT,
                    targetWidth: SIZE_AUTO,
                    targetHeight: SIZE_AUTO,
                    anchorOrigin: ORIGIN_BOTTOM_RIGHT,
                }}
            >
                <div>
                    <div>
                        <SuiLabel text={LAYOUT_LABEL} />
                        <Spacer $spacing={containerPaddingS} />
                        <IconContainer>
                            {options.map(({ label, Icon, layout }) => (
                                <LayoutIconCard
                                    data-qa={`${qaId}--LayoutOptionToggle--option--${layout}`}
                                    onClick={(e) => onOptionSelected(e, layout)}
                                    key={layout}
                                >
                                    <Icon />
                                    <label>{label}</label>
                                </LayoutIconCard>
                            ))}
                        </IconContainer>
                        <Spacer $spacing={containerPaddingS} />
                    </div>
                </div>
            </SuiPopoverMenu>
        </LayoutOptionStyled>
    );
}

LayoutOptionsMenu.propTypes = {
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            Icon: PropTypes.func,
            layout: PropTypes.string,
        }),
    ).isRequired,
    qaId: PropTypes.string.isRequired,
    ariaLabel: PropTypes.string,
};

LayoutOptionsMenu.defaultProps = {
    ariaLabel: DEFAULT_TRIGGER_BUTTON_ARIA_LABEL,
};
